/*
 * your moments — Cart Drawer Helfer
 *
 * 1) Animiert den Versand-Fortschrittsbalken:
 *    - beim Öffnen des Drawers füllt er sich von 0 auf den aktuellen Wert
 *    - bei Mengenänderungen läuft er weich vom alten auf den neuen Wert
 *    Nötig, weil Shopify den Drawer bei jeder Änderung serverseitig neu rendert
 *    und die Bar sonst hart auf dem neuen Wert erscheint. Der Zielwert steht in
 *    data-percent, der sichtbare Wert wird hier gesetzt.
 * 2) Öffnet den Drawer automatisch nach einem /cart-Redirect
 *    (Flag aus snippets/ym-cart-page-redirect.liquid).
 */
(function () {
  var FLAG = 'ym:open-cart-drawer';
  var DEBOUNCE = 90; // mehrere Re-Renders hintereinander zu einer Animation zusammenfassen
  var KICKOFF = 30; // kurze Pause, bevor der Zielwert gesetzt wird (startet die Transition)

  var displayed = 0; // aktuell sichtbarer Füllstand in Prozent
  var timer = null;

  /* ---------- Fortschrittsbalken ---------- */

  function applyBar() {
    var fill = document.querySelector('.ym-shipbar__fill');

    if (!fill) {
      // Keine Bar (leerer Warenkorb, Markt ohne Gratisversand)
      displayed = 0;
      return;
    }

    var target = parseFloat(fill.getAttribute('data-percent') || '0');
    if (isNaN(target)) target = 0;

    if (target === displayed) {
      fill.style.width = target + '%';
      return;
    }

    var from = displayed;
    displayed = target;

    fill.style.transition = 'none';
    fill.style.width = from + '%';
    void fill.offsetWidth; // Reflow erzwingen, sonst springt der Browser direkt zum Ziel
    fill.style.transition = '';

    // setTimeout statt requestAnimationFrame: feuert auch, wenn der Tab gerade
    // nicht sichtbar ist — sonst bliebe die Bar auf dem alten Wert stehen.
    window.setTimeout(function () {
      var el = document.querySelector('.ym-shipbar__fill');
      if (el) el.style.width = target + '%';
    }, KICKOFF);
  }

  function scheduleBar() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      applyBar();
    }, DEBOUNCE);
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver !== 'function') return;

    // Inhalt: Shopify tauscht bei jeder Änderung den Drawer-Inhalt aus
    new MutationObserver(scheduleBar).observe(drawer, { childList: true, subtree: true });

    // Öffnen: Bar von 0 hochlaufen lassen
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) {
        displayed = 0;
        scheduleBar();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Drawer nach /cart-Redirect öffnen ---------- */

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return false;
    drawer.open();
    return true;
  }

  function maybeOpen() {
    var flag = null;

    try {
      flag = sessionStorage.getItem(FLAG);
      if (flag) sessionStorage.removeItem(FLAG);
    } catch (e) {}

    if (!flag) return;

    if (!openDrawer()) {
      var tries = 0;
      var poll = window.setInterval(function () {
        tries += 1;
        if (openDrawer() || tries > 20) window.clearInterval(poll);
      }, 100);
    }
  }

  function init() {
    watchDrawer();
    maybeOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
